// src/redux/droneSlice.js
import { createSlice } from '@reduxjs/toolkit';

const droneSlice = createSlice({
  name: 'drone',
  initialState: {
    drones: [],
  },
  reducers: {
    addDrone(state, action) {
      action.payload.path.map(({path,id})=>
        state.drones.push({
          id: action.payload.id,
          path: path,
          currentIndex: 0,
          isSimulating: false,
        }) 
      )
      
    },
    updateDronePath(state, action) {
      const drone = state.drones.find((d) => d.id === action.payload.id);
      if (drone) {
        drone.path = action.payload.path;
        drone.currentIndex = 0;
      }
    },
    startSimulation(state, action) {
      const drone = state.drones.find((d) => d.id === action.payload.id);
      if (drone) {
        drone.isSimulating = true;
      }
    },
    stopSimulation(state, action) {
      const drone = state.drones.find((d) => d.id === action.payload.id);
      if (drone) {
        drone.isSimulating = false;
      }
    },
    updateCurrentIndex(state, action) {
      const drone = state.drones.find((d) => d.id === action.payload.id);
      if (drone) {
        console.log("ddo: ",drone)
        drone.currentIndex = action.payload.index;
      }
    },
  },
});

export const {
  addDrone,
  updateDronePath,
  startSimulation,
  stopSimulation,
  updateCurrentIndex,
} = droneSlice.actions;
export default droneSlice.reducer;